<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl
    URL="grupo?carreras_planes_id={{carreras_planes_id}}&periodos_escolares_id={{periodos_escolares_id}}&nivel={{nivel}}"
    titulo="Grupo / Control Escolar"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl" [filtro]="true"></app-tabla-opciones>

            <span id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 79vh;">
                <a id="catalogos"
                    (click)="ctrl.cargarCatalogo('becas', 'beca'); ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan'); ctrl.cargarCatalogo('modalidades', 'modalidad'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
                <a id="logo64" (click)="asignarLogos(ctrl.logos64);"></a>
                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th><abbr>#</abbr></th>
                            <!-- <th>Identificador</th> -->
                            <th></th>
                            <th>Clave</th>
                            <th>Grado</th>
                            <th>Carrera</th>
                            <th>Modalidad</th>
                            <th>Periodo</th>
                            <th>Alumnos</th>
                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <td style="vertical-align: middle;">{{ i + 1 }}</td>
                            <!-- <td style="vertical-align: middle;">{{ item.identificador }} </td> -->
                            <td style="vertical-align: middle;"><i *ngIf="item.en_campania==1"
                                    title="En campaña: Disponible en módulo de promoción"
                                    class="icon-volume has-text-link"> </i>
                            </td>

                            <td style="vertical-align: middle;">
                                {{ item.clave }}
                                <br>
                                <!--<span class="tag is-gray has-text-dark">
                                    {{item.tipo_rvoe}}
                                </span>-->
                                
                                
                            </td>

                            <td style="vertical-align: middle;">{{ item.nivel }} {{ item.identificador }} </td>
                            

                            <td style="vertical-align: middle;">
                                <span class="tooltiptext">{{ item.carreras_planes?.carreras?.nombre }}</span> 
                                <br>
                                <span
                                    class="tag has-text-dark"
                                    [ngClass]="{
                                        'is-light': item.tipo_rvoe === 'FEDERAL',
                                        'is-gray': item.tipo_rvoe === 'ESTATAL'
                                    }"
                                    >
                                    {{ item.tipo_rvoe }}
                                </span>

                                <span
                                    class="tag has-text-dark"
                                    [ngClass]="{
                                        'is-light': item.tipo_rvoe === 'FEDERAL',
                                        'is-gray': item.tipo_rvoe === 'ESTATAL'
                                    }"
                                    >
                                    {{ item.carreras_planes?.carreras?.niveles?.nombre }}
                                </span>

                               

                                <span
                                    class="tag has-text-dark"
                                    [ngClass]="{
                                        'is-light': item.tipo_rvoe === 'FEDERAL',
                                        'is-gray': item.tipo_rvoe === 'ESTATAL'
                                    }"
                                    >
                                     Rvoe: {{item.carreras_planes?.rvoe}}
                                </span>

                                <span class="tag has-text-dark"
                                    [ngClass]="{
                                        'is-light': item.tipo_rvoe === 'FEDERAL',
                                        'is-gray': item.tipo_rvoe === 'ESTATAL'
                                    }">
                                     {{item.carreras_planes?.planes?.nombre}}
                                </span>

                            </td>

                            <td style="vertical-align: middle;">
                                {{ item.periodos_escolares?.modalidades?.nombre }} 
                                
                            </td>
                            
                            <td style="vertical-align: middle;">{{ item.periodos_escolares?.nombre }} </td>

                            <td style="vertical-align: middle;">
                                <div class="level-left">
                                    <button class="navbar-item tooltip modal-button "
                                        (click)="asignarLogos(ctrl.logos64); nuevo_grupo($event,item.id, 'lista');">
                                        <span class="icon fa-2x  has-text-success">
                                            {{item.grupos_alumnos.length}}
                                        </span>
                                        <span class="tooltiptext">Alumnos: {{item.grupos_alumnos.length}}</span>
                                    </button>

                                    <button class="navbar-item tooltip is-danger" (click)="quitar_beca($event,item.id)">
                                        <span class="icon fa-2x  has-text-danger">
                                            <i class="icon-timer"></i>
                                        </span>
                                        <span class="tooltiptext">Quitar beca</span>
                                    </button>

                                    <button class="navbar-item tooltip is-info"
                                        (click)="nuevo_grupo($event,item.id, 'beca');">
                                        <span class="icon fa-2x  has-text-link">
                                            <i class="icon-donation-4"></i>
                                        </span>
                                        <span class="tooltiptext">Agregar beca</span>
                                    </button>

                                    <button class="navbar-item tooltip is-warning" (click)="reiniciar($event,item.id, 'reiniciar-conteo');"
                                    [disabled]="permisos.indexOf('GrupoController.reiniciar') <= 0">
                                        <span class="icon fa-2x  has-text-warning">
                                            <i class="icon-refresh-1"></i>
                                        </span>
                                        <span class="tooltiptext">Reiniciar conteo</span>
                                    </button>
                                </div>


                            </td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl"
                                    class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="10" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;"
                        [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="./assets/128x128.png" alt="Image">
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-medium has-text-link"> <small>Periodo: {{
                                                item.periodos_escolares?.nombre }}</small></strong>
                                        <strong class="tag is-medium has-text-success">
                                            Carrera: {{ item.carreras_planes?.carreras?.nombre }}
                                        </strong>
                                        <strong class="tag is-medium">
                                            Alumnos: {{ item.grupos_alumnos.length }}
                                        </strong>

                                        <!-- <strong class="tag is-medium">
                                            Clave: {{ item.identificador }}
                                        </strong> -->
                                        <strong class="tag is-medium">
                                            Clave: {{ item.clave }} {{ item.nivel }} {{ item.identificador }}
                                        </strong>

                                        <strong> has-text-link
                                            <i *ngIf="item.en_campania==1"
                                                title="En campaña: Para uso exclusivo del módulo de promoción"
                                                class="icon-volume"> </i>
                                        </strong>

                                        <strong class="tag is-medium">
                                            Nombre: {{ item.nombre }}
                                        </strong>

                                        <strong class="tag is-medium">
                                            Nivel: {{ item.nivel }}
                                        </strong>

                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">
                                        <!-- acciones -->
                                        <div class="level-left">
                                            <button class="navbar-item tooltip modal-button "
                                                (click)="asignarLogos(ctrl.logos64); nuevo_grupo($event,item.id, 'lista');">
                                                <span class="icon fa-2x  has-text-success">
                                                    {{item.grupos_alumnos.length}}
                                                </span>
                                                <span class="tooltiptext">Alumnos: {{item.grupos_alumnos.length}}</span>
                                            </button>

                                            <button class="navbar-item tooltip is-danger"
                                                (click)="quitar_beca($event,item.id)">
                                                <span class="icon fa-2x  has-text-danger">
                                                    <i class="icon-timer"></i>
                                                </span>
                                                <span class="tooltiptext">Quitar beca</span>
                                            </button>

                                            <button class="navbar-item tooltip is-info"
                                                (click)="nuevo_grupo($event,item.id, 'beca');">
                                                <span class="icon fa-2x  has-text-link">
                                                    <i class="icon-donation-4"></i>
                                                </span>
                                                <span class="tooltiptext">Agregar beca</span>
                                            </button>
                                        </div>

                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl"
                                            class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>

<div id="detalle-grupo" class="modal">
    <div class="modal-background"></div>
    <div *ngIf="detalles!=''" class="modal-card" style="width:95%; height: auto;">
        <header class="modal-card-head">
            <p class="modal-card-title"><strong>Clave : </strong> <small>{{detalles.clave}}</small></p>
            <button class="delete" aria-label="close" (click)="cerrar_modal()"></button>
        </header>
        <section class="modal-card-body">
            <!-- Content ... -->
            <nav class="level is-mobile">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Alumnos</p>
                        <p class="title">{{detalles.grupos_alumnos.length}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Nivel</p>
                        <p class="title">{{detalles.nivel}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Carrera</p>
                        <p class="title">{{detalles.carreras_planes.carreras.sigla}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Período escolar</p>
                        <p class="title">{{detalles.periodos_escolares.nombre}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Tipo período</p>
                        <p class="title">{{detalles.periodos_escolares.tipos_periodos.nombre}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Modalidad</p>
                        <p class="title">{{detalles.periodos_escolares.modalidades.nombre}}</p>
                    </div>
                </div>
            </nav>

            <div class="content">
                <!-- <h2>Lista de alumnos: </h2> -->
                <table class="table" style="width:100%;">
                    <thead>
                        <tr>
                            <th>MATRICULA</th>
                            <th>NOMBRE</th>
                            <th>CURP</th>
                            <th>CORREO</th>
                            <th>CONTACTO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of detalles.grupos_alumnos">
                            <th>{{item.alumnos.matricula}}</th>
                            <td>
                                <span class="tag"
                                    [ngClass]="item.estatus_alumno.color">{{item.estatus_alumno.etiqueta}}</span>
                                <span *ngIf="item.alumnos.sexo==='F'"
                                    class="fa fa-female has-text-danger"></span>
                                <span *ngIf="item.alumnos.sexo==='M'"
                                    class="fa fa-male has-text-warning"></span>
                                {{item.alumnos.apellido_paterno}}
                                {{item.alumnos.apellido_materno}}
                                {{item.alumnos.nombre}}
                            </td>
                            <td>{{item.alumnos.curp}}</td>
                            <td>{{item.alumnos.email}}</td>
                            <td><span *ngFor="let val of item.alumnos.contactos"> {{val.valor}} </span></td>
                        </tr>
                        <tr *ngIf="detalles.grupos_alumnos.length == 0">
                            <td colspan="4" style="text-align:center;">Sin alumnos en el grupo</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </section>
        <footer class="modal-card-foot">
            <button class="button" (click)="cerrar_modal()">Ok!</button>
            <button class="button is-success  is-pulled-right" (click)="imprimirLista(true)"> <i
                    class="icon-document"></i> Imprimir lista asistencia</button>
            <button class="button is-link  is-pulled-right" (click)="imprimirLista(false)"> <i
                    class="icon-document"></i> Imprimir lista</button>
            <button class="button is-link  is-pulled-right" (click)="imprimirLista(2)"> <i class="icon-document"></i>
                Imprimir</button>

            <button class="button is-link  is-pulled-right" (click)="exportarListaExcel(detalles.grupos_alumnos,detalles,detalles.clave,detalles.nivel,detalles.identificador,detalles.carreras_planes.carreras.sigla, detalles.periodos_escolares.fecha_inicio)"> <i
                    class="icon-document"></i> Exportar Excel</button>

            <div class="b-checkbox is-info">
                <input type="checkbox" id="baja" name="baja" [(ngModel)]="baja"
                    [ngModelOptions]="{standalone: true}">
                <label for="baja">
                    Imprimir alumnos BAN
                </label>
            </div>
        </footer>
    </div>
</div>


<!-- MODAL FILTROS -->
<div class="modal" id="filtros"> 
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 60%;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="fa fa-filter"></i>
                </span> Filtrar
            </p>
            <button type="button" class="delete" (click)="cancelarFiltros('filtros')"></button>
        </header>
        <section class="modal-card-body">

            <div class="columns">
                <div class="column is-12">
                    <label class="label">Periodo Escolar:</label>
                    <div class="control has-icons-left has-icons-right">
                        <div class="select">
                            <select class="select" [(ngModel)]="periodos_escolares_id">
                                <option value="">Seleccione periodo escolar</option>
                                <option *ngFor="let item of ctrl.periodos_escolares" value="{{item.id}}">{{ item.nombre
                                    }} / {{item.modalidades?.nombre}} / {{ item.tipos_periodos?.nombre }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column is-9">
                    <!-- <label class="label">Modalidad</label>
          <div class="control has-icons-left has-icons-right">
              <div class="select">
                  <select class="select" [(ngModel)]="modalidades_id">
                      <option value="">Seleccione una modalidad</option>
                      <option *ngFor="let item of ctrl.modalidades" value="{{item.id}}">{{item.nombre}}</option>
                  </select>
              </div>
          </div> -->
                    <label class="label">Carreras Planes:</label>
                    <div class="control has-icons-left has-icons-right">
                        <div class="select">
                            <select class="select" [(ngModel)]="carreras_planes_id">
                                <option value="">Seleccione carrera plan</option>
                                <option *ngFor="let item of ctrl.carreras_planes" value="{{item.id}}">{{item.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="field">
                        <label class="label">Nivel:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="number" placeholder="Nivel" [(ngModel)]="nivel">

                            <!-- <span class="help is-danger" *ngIf="!ctrl.dato.controls.personas_rfcs.controls[i].controls.razon_social.valid">Este campo es requerido.</span> -->
                        </p>
                    </div>
                </div>
            </div>

        </section>
        <footer class="modal-card-foot">
            <a class="button is-success"
                (click)="ctrl.listar(1); cancelarFiltros('filtros'); filtro=true; fNombreGrupo();">Aplicar filtros</a>
            <a class="button"
                (click)="cancelarFiltros('filtros'); filtro=false; grupos_id=''; carreras_planes_id=''; periodos_escolares_id=''; nombreGrupo = '';">Quitar
                filtros</a>
        </footer>
    </div>
</div>
<!-- MODAL FILTROS -->

<!-- QUITAR BECA -->
<div class="modal" id="quitar-beca">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Confirmación</p>
            <button class="delete" (click)="cancelarFiltros('quitar-beca')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Está seguro que desea remover las becas para los alumnos del grupo?</h1>
                <p>Ya no se podra recuperar la información</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="borrar_beca(item)"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="cancelarFiltros('quitar-beca')">Cancelar</a>
        </footer>
    </div>
</div>
<!-- QUITAR BECA -->

<!-- AGREGAR BECA -->
<div class="modal" id="agregar-beca">
    <div class="modal-background"></div>
    <div class="modal-card" style="width:80%; height: auto;">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Agregar beca</p>
            <button class="delete" (click)="cancelarFiltros('agregar-beca')"></button>
        </header>
        <section class="modal-card-body" *ngIf="detalles!=''">
            <div class="content">
                <div class="content">
                    <!-- <h2>Lista de alumnos: </h2> -->
                    <table class="table" style="width:100%;">
                        <thead>
                            <tr>
                                <th>NOMBRE</th>
                                <th>CURP</th>
                                <th>CORREO</th>
                                <th>BECA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of detalles.grupos_alumnos">
                                <td> <span *ngIf="item.alumnos.sexo==='F'"
                                        class="fa fa-female has-text-danger"></span>
                                    <span *ngIf="item.alumnos.sexo==='M'"
                                        class="fa fa-male has-text-warning"></span>
                                    {{item.alumnos.apellido_paterno}}
                                    {{item.alumnos.apellido_materno}}
                                    {{item.alumnos.nombre}}
                                </td>
                                <td>{{item.alumnos.curp}}</td>
                                <td>{{item.alumnos.email}}</td>
                                <td>
                                    <div class="control " style="width: 100%;">
                                        <select class="select" name="becas_id" [(ngModel)]="item.becas_id">
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let val of ctrl.becas" value="{{val.id}}">{{ val.nombre }}
                                            </option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="detalles.grupos_alumnos.length == 0">
                                <td colspan="4" style="text-align:center;">Sin alumnos en el grupo</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="asignar_beca()"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="cancelarFiltros('agregar-beca')">Cancelar</a>
        </footer>
    </div>
</div>
<!-- AGREGAR BECA -->

<!-- REINICIAR CONTEO -->
<div class="modal" id="reiniciar-conteo">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Confirmación</p>
            <button class="delete" (click)="cancelarFiltros('reiniciar-conteo')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Está seguro que desea reiniciar el conteo de alumnos?</h1>
                <p>Ya no se podra recuperar la información</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="reincia_conteo(item)"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="cancelarFiltros('reiniciar-conteo')">Cancelar</a>
        </footer>
    </div>
</div>
<!-- FINALIZA -->